import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-folder-empty-view',
  templateUrl: './folder-empty-view.component.html',
  styleUrl: './folder-empty-view.component.css'
})
export class FolderEmptyViewComponent implements OnInit {

  @Input() folderSelected: boolean = false;

  ngOnInit(): void {
    
  }
}
